<div [formGroup]="formGroup">
  <tui-input-phone
    [formControlName]="formControlName"
    [countryCode]="''"
    [phoneMaskAfterCountryCode]="mask"
    [nativeId]="id"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [pseudoFocus]="focus ?? null"
    [readOnly]="properties?.readOnly ?? false"
    (focusedChange)="handleFocusedChange($event)"
  >
    {{ label }}
    <span
      class="tui-required"
      *ngIf="validators.required"
    ></span>
    <input
      tuiTextfield
      inputmode="numeric"
      [attr.placeholder]="placeholder ?? ''"
      [attr.required]="validators.required"
    />
  </tui-input-phone>
</div>
